if($(".description-div-parent").length > 0)
{
// Description tab opened
function descriptionDivheightFunction() {
  var
      descriptionDivParent = document.getElementsByClassName('description-div-parent')[0],
      descriptionDivChild = document.getElementsByClassName('description-div-child')[0],
      descriptionDivHeight = descriptionDivChild.clientHeight;

      descriptionDivParent.setAttribute('style', 'height:' + descriptionDivHeight + 'px;')
}

descriptionDivheightFunction();

window.addEventListener("resize", descriptionDivheightFunction);
};

const 
  locatioURL = location.href.toString(),
  tagsToSearch = locatioURL.includes('/tagged/lifestyle') || locatioURL.includes('/tagged/our-history') || locatioURL.includes('/tagged/sun');
  tagsToSearchFurthest = locatioURL.includes('/tagged/sustainability') || locatioURL.includes('/tagged/trending') || locatioURL.includes('/tagged/we-care');

if ( tagsToSearch === true ) {
  document.getElementsByClassName("page-width overflow-x-scroll")[0].scrollLeft += 380;
} else if ( tagsToSearchFurthest === true ) {
  document.getElementsByClassName("page-width overflow-x-scroll")[0].scrollLeft += 760;
};

$(document).ready(function() {
    // Configure/customize these variables.
//     var showChar = 250;  // How many characters are shown by default
//     var ellipsestext = "&nbsp...";
//     var moretext = "Read More";
//     var lesstext = "Read Less";
    

//     $('.more').each(function() {
//         var content = $(this).html();
 
//         if(content.length > showChar) {
 
//             var c = content.substr(0, showChar);
//             var h = content.substr(showChar, content.length - showChar);
 
//             var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
 
//             $(this).html(html);
//         }
 
//     });
 
//     $(".all-in-one > span").click(function(){
//         if($(this).hasClass("less")) {
//             $(this).removeClass("less");
//             $(this).html(moretext);
//         } else {
//             $(this).addClass("less");
//             $(this).html(lesstext);
//         }
//         $(this).parent().prev().toggle();
//         $(this).prev().toggle();
//         return false;
//     });
  
  $('.read-more-collection').on('click', function(){
    $('#truncated , #truncated1 ').fadeOut(200, function(){ 
      $('#fullDescription').fadeIn(400);
      $('.read-less-collection').css('display','inline-block');
    })
  });
  
  $('.read-less-collection').on('click', function(){
    $('#fullDescription').fadeOut(200, function(){ 
      $('#truncated , #truncated1').fadeIn(400);
      $('.read-less-collection').css('display','none');
    })
  });

  // This is resposible to hidding collection ads on filter
  var checkUrlHideOrShowCollectionAds = function() {
    $('.collection-advertisements').hide();

    if ( window.location.href.indexOf("filter") > -1 ) {
      $('.collection-advertisements').hide();
    } else {
      $('.collection-advertisements').show();
    }
  }

  $(document).ready(function() {
    checkUrlHideOrShowCollectionAds();
  });

  $(document).on('click', '.tag', function() {
    setInterval(checkUrlHideOrShowCollectionAds, 100)
  });

  // Hiding the image slides and promo grid when no content
  $(document).ready(function() {
    $('.image-slides--hidden, .promo-grid--hidden').each(function() {
      $(this).parent('div').hide();
    });

    // Hiding the text columns with images fluid when no content
    $('.grid--flush-bottom').each(function() {
      var $grid = $(this);

      if ($.trim($grid.html()) === '') {
        $grid.closest('.index-section.color-scheme-none').hide();
      }
    });
  });
});
